import { render, staticRenderFns } from "./PartnershipB.vue?vue&type=template&id=eb897cee&scoped=true"
import script from "./PartnershipB.vue?vue&type=script&lang=js"
export * from "./PartnershipB.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb897cee",
  null
  
)

export default component.exports